import script from "./RecursionConfirmModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecursionConfirmModal.vue?vue&type=script&setup=true&lang=ts"

import "./RecursionConfirmModal.vue?vue&type=style&index=0&id=7d01a1e3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d01a1e3"]])

export default __exports__